import React, { useState } from 'react'
import { Col, Collapse, Row, Space } from 'antd'
import { ButtonEx, DetailSelectionModal, Text } from '../../shared.style'
import SuccessIcon from '../../assets/icons/success.png'
import SuccessDuplicateIcon from '../../assets/icons/success_duplicate.png'
import _ from 'lodash'
import axios from 'axios'
import { useDeepEffect } from '../../utils/hooks'

const { Panel } = Collapse

const DetailSelectionItem = ({ src, material, active, onClick }) => {
  return (
    <Row
      style={{ marginBottom: '10px', cursor: 'pointer' }}
      onClick={() => onClick(material)}>
      <Col span={22}>
        <Space>
          <img src={material.image} alt="" width={48} height={48} />
          <Text>{material.name}</Text>
        </Space>
      </Col>
      <Col span={2}>
        <Row justify="center" align="middle">
          {active && (
            <div style={{ marginTop: '1rem' }}>
              <img src={src} alt="" width={24} height={24} />
            </div>
          )}
        </Row>
      </Col>
    </Row>
  )
}

const DetailSelection = ({
  visible,
  onCancel,
  detailKey,
  materialBinList,
  onClickItem,
  onOk
}) => {

  const [categories, setCategories] = useState([])

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/product/groupByCategory`
      )
      setCategories(res.data)
    } catch (err) {
      console.log(err)
    }
  }


  useDeepEffect(() => {
    fetchCategories()
  }, [])

  console.log(categories)

  const onClick = (material) => {
    onClickItem(material, detailKey)
  }

  const renderItemActive = (item, index) => {
    let active = false

    materialBinList.forEach((bin) => {
      const isDuplicate = _.some(bin.materialBins, (material) => {
        return material.id === item.id
      })

      if (isDuplicate) {
        active = true
      } else {
        if (bin.id === index) {
          bin.materialBins.forEach((material) => {
            if (material.id === item.id) {
              active = true
            }
          })
        }
      }
    })

    return active
  }

  const renderSuccessActive = (item, index) => {
    let active = false
    materialBinList.forEach((bin, idx) => {
      const isDuplicate = _.some(bin.materialBins, (material) => {
        return material.id === item.id
      })

      if (isDuplicate) {
        active = detailKey !== idx
      } else {
        if (bin.id === index) {
          bin.materialBins.forEach((material) => {
            if (material.id === item.id) {
              active = true
            }
          })
        }
      }
    })

    return active ? SuccessDuplicateIcon : SuccessIcon
  }
  return (
    <DetailSelectionModal
      width={800}
      title="เลือกอย่างละเอียด"
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Collapse accordion expandIconPosition="right">
        {categories &&
          categories.map((category, idx) => {
            return (
              <Panel
                header={
                  <span style={{ color: '#6ebf4b' }}>{category.categoryName}</span>
                }
                key={idx}>
                {category.materialList.map((material, index) => {
                  return (
                    <DetailSelectionItem
                      src={renderSuccessActive(material, index)}
                      active={renderItemActive(material, index)}
                      material={material}
                      key={index}
                      onClick={onClick}
                    />
                  )
                })}
              </Panel>
            )
          })}
      </Collapse>
      <Row justify="center" style={{ margin: '1rem 0' }}>
        <Space>
          <ButtonEx onClick={() => onCancel()}>ยกเลิก</ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" onClick={() => onOk()}>
            ตกลง
          </ButtonEx>
        </Space>
      </Row>
    </DetailSelectionModal>
  )
}

export default DetailSelection



// WEBPACK FOOTER //
// ./src/components/DetailSelection/index.js